module.exports = __webpack_public_path__ + "static/img/ARAD3_2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/ARAD3_2.png
// module id = qKAk
// module chunks = 0